// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import ContentLoaderController from "./content_loader_controller.js"
application.register("content-loader", ContentLoaderController)

import CheckboxSelectAll from "./../checkbox-select-all";
application.register("checkbox-select-all", CheckboxSelectAll)

import DependentSelectController from "./dependent_select_controller.js"
application.register("dependent-select", DependentSelectController)

import JobCodesBulkController from "./job_codes_bulk_controller.js"
application.register("job-codes-bulk", JobCodesBulkController)

import PasswordVisibilityController from "./password_visibility_controller.js"
application.register("password-visibility", PasswordVisibilityController)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)
